export default __webpack_public_path__ + "1019be91c700e4656b935f3b29cb6b94.png";